"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const fieldAlreadyAttachedError = (label) => new Error(`Tried to re-attach a field with label "${label}". Fields can only be attached to a Form instance once.`);
class FieldState {
    constructor({ label = '', defaultValue, value = defaultValue, validators = [], disabled = false, onChange = undefined }) {
        Object.defineProperty(this, "label", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_defaultValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_initialValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_validators", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_onChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_isDisabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_parentForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.label = label;
        this._defaultValue = defaultValue;
        this._initialValue = value;
        this._validators = validators;
        this._onChange = onChange;
        this._value = value;
        this._isDisabled = disabled;
        (0, mobx_1.makeAutoObservable)(this);
        this.setUpOnChangeReaction();
    }
    get value() {
        return this._value;
    }
    get isValid() {
        return !this.failedValidationResult;
    }
    get isDirty() {
        return this._value !== this._initialValue;
    }
    get isDisabled() {
        return this._isDisabled;
    }
    get error() {
        var _a;
        return (_a = this.failedValidationResult) === null || _a === void 0 ? void 0 : _a.error;
    }
    get parentForm() {
        return this._parentForm;
    }
    setValue(newValue) {
        this._value = newValue;
    }
    setIsDisabled(isDisabled) {
        this._isDisabled = isDisabled;
    }
    clear() {
        this._value = this._defaultValue;
    }
    reset() {
        this._value = this._initialValue;
    }
    attachToForm(form) {
        if (this._parentForm)
            throw fieldAlreadyAttachedError(this.label);
        this._parentForm = form;
    }
    setUpOnChangeReaction() {
        (0, mobx_1.reaction)(() => this._value, (newValue) => { var _a; return (_a = this._onChange) === null || _a === void 0 ? void 0 : _a.call(this, newValue, this._parentForm); });
    }
    get failedValidationResult() {
        return this.validationResults.find(result => !result.isValid);
    }
    get validationResults() {
        return this._validators.map(validator => validator(this._value, this._parentForm, this.label));
    }
}
exports.default = FieldState;
